import type { ReactNode } from 'react';
import { instalacion } from '@tanteo/compartido/instalacion';

/**
 * `data-e2e` se declara explícitamente: JSX acepta atributos con guion sin avisar, y en un
 * componente que no los reenvía el selector nunca llega al DOM. Se declara este y no un `...props`
 * abierto, para que la superficie siga siendo una tarjeta.
 */
export function Tarjeta({
  children,
  className = '',
  'data-e2e': e2e,
}: {
  children: ReactNode;
  className?: string;
  'data-e2e'?: string;
}) {
  return (
    <div className={`rounded-card bg-card border border-border p-4 ${className}`} data-e2e={e2e}>
      {children}
    </div>
  );
}

/** Separador vertical entre bloques de una barra o un título. */
export function Divisor({ className = '' }: { className?: string }) {
  return <span aria-hidden className={`bg-border h-6 w-px self-center ${className}`} />;
}

/**
 * El logotipo. Un solo sitio para el degradado de marca y el peso de la tipografía. Si la ficha trae
 * `logo`, pinta su imagen (horizontal en el encabezado, completa en portada e ingreso) en el tema activo.
 */
export function Marca({ className = '', variante = 'horizontal' }: { className?: string; variante?: 'horizontal' | 'completo' }) {
  const logo = instalacion.logo?.[variante];
  if (logo)
    return (
      <span className={`marca-logo marca-logo-${variante} ${className}`}>
        <img className="marca-logo-claro" src={logo.claro} alt={instalacion.nombre} />
        <img className="marca-logo-oscuro" src={logo.oscuro} alt={instalacion.nombre} />
      </span>
    );
  return <span className={`texto-degradado font-extrabold ${className}`}>{instalacion.textos.marca}</span>;
}

/** «una aplicación de [logo] by …»: la autoría que la ficha declara. Sin `autoria`, no pinta nada. */
export function Autoria({ className = '' }: { className?: string }) {
  const a = instalacion.autoria;
  if (!a) return null;
  return (
    <p className={`text-muted marca-autoria text-etiqueta ${className}`}>
      <span>{a.antes}</span>
      <span className="marca-logo">
        <img className="marca-logo-claro" src={a.logo.claro} alt={a.alt} />
        <img className="marca-logo-oscuro" src={a.logo.oscuro} alt={a.alt} />
      </span>
      <span>{a.despues}</span>
    </p>
  );
}
